import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import CloseToTerrainStage, { CloseToTerrainParameters } from '../stages/filters/CloseToTerrainStage';

export interface CloseToTerrainBlockParams extends BlockParameters, CloseToTerrainParameters {}

@AddMetadata({
    type: BlockKeys.CloseToTerrain,
    name: 'Close to Terrain',
    description: 'Filter out sensors that are not within a certain distance from the ground',
})
class CloseToTerrainBlock extends PipelineBlock<CloseToTerrainBlockParams> {
    constructor(params: CloseToTerrainBlockParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new CloseToTerrainStage(this.getParams())];
    }
}

export default CloseToTerrainBlock;
